import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import FingerprintImg from 'assets/images/fingerprint.svg';
import LogoImg from 'assets/images/fdrpLogo.png';

import { acceptCodeOfHonor } from '../modules/actions';

import './styles.css';

import { ButtonCommit } from './styles';

class CodeOfHonor extends Component {
  handleCodeOfHonor = () => {
    const { onAccept } = this.props;
    onAccept();
  }

  render() {
    const { literals } = this.props;
    return (
      <Grid container spacing={0} className='CodeOfHonor'>
        <Grid item xs={12} className='CodeOfHonorContent' style={{ justifyContent: 'center' }}>
          <div className='wrapper'>
            <h1 className='CodeOfHonor__title'>{literals.title}</h1>
            <div className='CodeOfHonor__description'>
              <p>{literals.p1}</p>
              <p>{literals.p2}</p>
            </div>
            <div className='CodeOfHonor__action'>
              <img src={FingerprintImg} alt='fingerprint' className='CodeOfHonor__action__img' />
              <ButtonCommit
                onClick={this.handleCodeOfHonor}
              >
                {literals.actionBtn}
              </ButtonCommit>
            </div>
          </div>
        </Grid>
      </Grid>
    );
  }
}

CodeOfHonor.displayName = 'CodeOfHonor';
CodeOfHonor.propTypes = {
  literals: PropTypes.object.isRequired,
  onAccept: PropTypes.func.isRequired,
  showLoading: PropTypes.func.isRequired,
};
export default CodeOfHonor;



// WEBPACK FOOTER //
// ./src/components/CodeOfHonor/components/index.js